import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { Providers } from '@/app/Providers';
import { createQueryClient } from '@/app/queryClient';
import { createRouter } from '@/app/router';
import { i18n } from '@/lib/i18n';
import { env } from '@/lib/env';
import './styles.css';

async function start(): Promise<void> {
  // The mock service worker is opt-in through `VITE_ENABLE_MSW`, so the dev
  // server runs with no backend while never being mistaken for one.
  if (env.mswEnabled && import.meta.env.DEV) {
    const { worker } = await import('@/mocks/browser');
    await worker.start({ onUnhandledRequest: 'bypass' });
  }

  const container = document.getElementById('root');
  if (!container) throw new Error('index.html is missing #root.');

  const queryClient = createQueryClient();
  const router = createRouter(queryClient);
  document.documentElement.lang = i18n.language;

  createRoot(container).render(
    <StrictMode>
      <Providers queryClient={queryClient} i18n={i18n}>
        <RouterProvider router={router} />
      </Providers>
    </StrictMode>,
  );
}

void start();
